import { Component, OnInit, Output, Input, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import { TranslateService } from 'src/app/Services/translate.service';
import { MatDialog } from '@angular/material';
import { Router, NavigationExtras } from '@angular/router';
import { ChangePasswordComponent } from './../change-password/change-password.component';
import { UserProfileComponent } from './../user-profile/user-profile.component';
import { Session } from 'inspector';
import { UpdateProfileComponent } from '../update-profile/update-profile.component';
import { TimerConfirmComponent } from '../timer-confirm/timer-confirm.component';
import { LoginService } from '../../Services/login.service';
import { Observable, timer, Subscription } from 'rxjs';

import * as moment from 'moment';
import { EventEmitterService } from 'src/app/event-emitter.service';
import { QuoteService } from 'src/app/Modules/motor/Modules/quote/Services/quote.service';
import { UnderconstructionComponent } from './../underconstruction/underconstruction.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
  // template: `
  // <countdown [config]="{leftTime: 30}"></countdown>
  // `
})
export class HeaderComponent implements OnInit {
  selected = 'ENG';
  languages: any; 
  dispName: any; 
  check: boolean;
  flag: boolean;
  constructor(public _global: GlobalService, private quoteService: QuoteService,
    private translate: TranslateService, private router: Router, public dialog: MatDialog, private loginservice: LoginService, private ref: ChangeDetectorRef, private eventEmitterService: EventEmitterService) {
    this.searchEndDate = this.SearchDate.add(this.ElapsTime, "minutes");

  }

  openchangepassDialog(): void { 
    sessionStorage.getItem('userName');
    const dialogRef = this.dialog.open(ChangePasswordComponent, {
      panelClass: 'dialogPopclass',
      width: '350px'
    });
  }

  openuserProfileDialog(): void {

    const dialogRef = this.dialog.open(UserProfileComponent, {
      panelClass: 'dialogPopclass',
      width: '740px'
    });
  }

  
  openuserUnderDialog(): void {

    const dialogRef = this.dialog.open(UnderconstructionComponent, {
      panelClass: 'dialogPopclass',
      width: '550px'
    });
  }
  //  openuserProfileDialog1(): void {

  //   const dialogRef = this.dialog.open(TimerConfirmComponent, {
  //        panelClass: 'dialogPopclass',
  //        width: '495px'
  //    });
  //  }

  openupdateProfileDialog(): void {

    let navigationExtras: NavigationExtras = {
      queryParams: {
        "userName": sessionStorage.getItem('userName'),
        "flowMode": "update",
      }
    }
    if(this._global.usertype !="CSR"){
    this.router.navigate(["/dashboard/dashboard"], navigationExtras);
    }else{
      this.router.navigate(["/dashboard/csr-dashboard"], navigationExtras);
    }
    const dialogRef = this.dialog.open(UpdateProfileComponent, {
      panelClass: 'dialogPopclass',
      width: '495px'
    });
  }

  private subscription: Subscription;
  @Output() TimerExpired: EventEmitter<any> = new EventEmitter<any>();
  @Input() SearchDate: moment.Moment = moment();
  @Input() ElapsTime: number = this._global.time;
  searchEndDate: moment.Moment;
  remainingTime: number;
  minutes: number;
  seconds: number;
  everySecond: Observable<number> = timer(0, 1000);

  ngOnInit() {  
   this.dispName = sessionStorage.getItem('dispName')
if(this._global.selectLang == "en"){
  this.selected = 'ENG'; 
} 
else{
  this.selected = 'VET'; 
} 


    if (sessionStorage.getItem('langFlag') != undefined && sessionStorage.getItem('langFlag') == 'true') {
      this.loginservice.checkedvalues(null).subscribe((data: any) => {
        if (data.responseBody.Detail != null) {
          this.languages = data.responseBody.Detail;
          sessionStorage.removeItem('langFlag');
        }
      });
    }
    // Angular Timer Start
    // if(localStorage.getItem('initFlag')!=undefined && localStorage.getItem('initFlag')=='true'){

    //   this.flag=false;
    //   this.check=false;
    //   localStorage.removeItem('initFlag');
    // }
    //   if (this.eventEmitterService.subsVar==undefined) {    
    //     this.eventEmitterService.subsVar = this.eventEmitterService.    
    //     invokeFirstComponentFunction.subscribe((name:string) => {    
    //       this.firstFunction();    
    //     });    
    //   }    

    //   if(this.flag==undefined || this.flag!=true){
    //   this.subscription = this.everySecond.subscribe((seconds) => {
    //   var currentTime: moment.Moment = moment();
    //   this.remainingTime = this.searchEndDate.diff(currentTime)
    //   this.remainingTime = this.remainingTime / 1000;
    //   if (this.remainingTime <= 0 &&  this.flag!=true) {
    //   this.SearchDate = moment();
    //   this.flag=true;
    //   if(this.flag!=undefined && this.flag==true){

    //     }

    // this.ngOnInit();

    //   }
    //   else {
    //     this.flag=false;


    //   this.minutes = Math.floor(this.remainingTime / 60);
    //   this.seconds = Math.floor(this.remainingTime - this.minutes * 60);
    //           }
    //   })
    // }
    // else if(this.check!=true){

    //   this.check=true;
    //   const dialogRef = this.dialog.open(TimerConfirmComponent, {
    //         panelClass: 'dialogPopclass',
    //        width: '495px',
    //        disableClose: true 
    //      });

    // }
  }


  // Angular Timer End

  // javascript timer
  //   ngOnInit() {

  //   
  //   this.loginservice.checkedvalues(null).subscribe((data:any)=>{
  //     if(data.responseBody.Detail != null){
  //       this.languages=data.responseBody.Detail;
  //     }
  //   });
  //   sessionStorage.setItem('timeIn','false');
  //   if(sessionStorage.getItem('firstTimeLogin')!="true"){
  //    // alert("firstTimeLogin if1");
  //   document.getElementById("minute").innerHTML =sessionStorage.getItem('minutes') ;  
  //         document.getElementById("second").innerHTML = sessionStorage.getItem('seconds');
  //   }
  //   else{
  //     //alert("firstTimeLogin else1");
  //     sessionStorage.removeItem('firstTimeLogin');
  //     sessionStorage.removeItem('minutes') ;  
  //     sessionStorage.removeItem('seconds');
  //   }
  //         //alert("timeIn"+sessionStorage.getItem('timeIn'));
  //   if(sessionStorage.getItem('timeIn')==undefined || sessionStorage.getItem('timeIn')!='true'){
  //   var dt = new Date();
  //  //alert("session val::"+sessionStorage.getItem('minutes'));
  //   if((sessionStorage.getItem('minutes')!=undefined && sessionStorage.getItem('seconds')!=undefined )||
  //   (sessionStorage.getItem('minutes')!=null && sessionStorage.getItem('seconds')!=null )){
  //    // alert("if1");
  //   dt.setMinutes(dt.getMinutes() + parseInt(sessionStorage.getItem('minutes')));
  //   dt.setSeconds(dt.getSeconds() + parseInt(sessionStorage.getItem('seconds')));
  //   }
  //   else{
  //     //alert("else1");
  //     dt.setMinutes( dt.getMinutes() + 30 );
  //   }
  //   sessionStorage.setItem('timeIn','true');
  //   var deadline = dt.getTime(); 
  // var x = setInterval(function() { 
  //   //
  // var now = new Date().getTime(); 

  // var t = deadline - now; 
  // var days = Math.floor(t / (1000 * 60 * 60 * 24)); 
  // var hours = Math.floor((t%(1000 * 60 * 60 * 24))/(1000 * 60 * 60)); 
  // var minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60)); 
  // var seconds = Math.floor((t % (1000 * 60)) / 1000); 
  // //alert('mins'+minutes.toString());
  // //alert('secs'+seconds.toString());
  // sessionStorage.setItem('minutes',minutes.toString());
  // sessionStorage.setItem('seconds',seconds.toString());

  //      // (<HTMLInputElement>document.getElementById('quoteNo')).value=res.responseBody.quoteNo;
  // console.log('days'+days.toString());
  // // document.getElementById("day").innerHTML =days.toString(); 
  // // document.getElementById("hour").innerHTML =hours.toString(); 
  // document.getElementById("minute").innerHTML = sessionStorage.getItem('minutes');  
  // document.getElementById("second").innerHTML =sessionStorage.getItem('seconds');  

  // //alert("minutes"+minutes);
  // //alert("seconds"+seconds);
  // //

  // if (minutes == 0 && seconds == 0) { 
  //         clearInterval(x); 
  //       //  alert("Are you want continue or quit");
  //         sessionStorage.setItem('timeOut','true');
  //         //this.openuserProfileDialog1();
  //         
  //         sessionStorage.setItem('minutes','0');
  //         sessionStorage.setItem('seconds','0');
  //         //document.getElementById("demo").innerHTML = "TIME UP"; 
  //         //document.getElementById("day").innerHTML ='0'; 
  //         //document.getElementById("hour").innerHTML ='0'; 
  //         document.getElementById("minute").innerHTML ='0' ;  
  //         document.getElementById("second").innerHTML = '0';
  //         location.reload();
  //        // this.ngOnInit();
  //        } 

  // //       else if (minutes.toString().includes("-") || seconds.toString().includes("-")) { 
  // // sessionStorage.clear();

  // // this.router.navigate(["home"]);
  // //       }
  //         else{
  //           sessionStorage.setItem('timeOut','false');
  //         }
  // }, 1000); 
  //   }
  //   else{
  //     alert("Else");
  //   }
  // 
  // if(sessionStorage.getItem('timeOut')!=undefined && sessionStorage.getItem('timeOut')=='true'){
  //   
  //   this.ngOnInit();
  //   sessionStorage.setItem('minutes',"0");
  // sessionStorage.setItem('seconds',"0");

  //   document.getElementById("minute").innerHTML ='0' ;  
  //   document.getElementById("second").innerHTML = '0';
  //   const dialogRef = this.dialog.open(TimerConfirmComponent, {
  //     panelClass: 'dialogPopclass',
  //     width: '495px'
  // });
  // sessionStorage.setItem('timeOut','true');
  // }
  //   }
  firstFunction() {

    //this.flag=false;

    this.searchEndDate = this.SearchDate.add(this.ElapsTime, "minutes");

    localStorage.setItem('initFlag', 'true');
    // this.ngOnInit();
  }

  contactclick() {

    let navigationExtras: NavigationExtras = {
      queryParams: {
        "id": "5"
      }
    }
    this.router.navigate(["/listing/contactUs"], navigationExtras);
  }

  // var agentname = sessionStorage.getItem('userName'); 
  logout() {
    //  alert("logout");

    sessionStorage.clear();
    var n = sessionStorage.length;
    while (n--) {
      var key = sessionStorage.key(n);
      if (/foo/.test(key)) {
        sessionStorage.removeItem(key);
      }
    }
    sessionStorage.setItem('homeReload', 'true');
    this.router.navigate(["home"]);
    //to unlock the QQ
    
    var unlock = sessionStorage.getItem('LOCK');
    if (unlock == "L") {
      
      var userName = sessionStorage.getItem('userName');
      this.quoteService.unlockQuotedetails(userName).subscribe((data: any) => {
        
      })
    }
    //END
    //TO DELETE THE POLICY DETAILS UNDER STANDALONE receipting
    var Stdreceipting = sessionStorage.getItem('StandaloneDel');
    if (Stdreceipting == "DeletePolDtls") {
      
      var RHsysid = sessionStorage.getItem('RHSYSID');
      this.quoteService.deleteStdPolicyDtls(RHsysid).subscribe((data: any) => {
        
        if (data.responseBody.Validation == "PolicyDtlsremoved") {
          sessionStorage.removeItem("StandaloneDel");
          sessionStorage.removeItem("RHSYSID");
        }
      })
    }
    //END


  }
  onChange(eve) {

    if (eve.value == "VET") {
      this._global.pageDir = "ltr"
      this._global.selectLang = "vn";
      this._global.showArabic = true;
    } else if (eve.value == "ENG") {
      this._global.pageDir = "ltr"
      this._global.selectLang = "en";
      this._global.showArabic = false;
    }
    else {
      this._global.pageDir = "ltr"
      this._global.selectLang = "ar";
      this._global.showArabic = false;
    }
    this.translate.use(this._global.selectLang).then((data) => {
      this._global.loadPageContent(window.location.href);
      this._global.menuContent = this.translate.data["menu"];
      this._global.commonContent = this.translate.data["commonmessage"];
      this._global.headerEmitter.emit("language change");
    });
  }

}
